import React from "react";
import { Avatar } from "@mui/material";
import { useStyles } from "./styles";
import { handleKeyActivate } from "@/main/services/utils";

interface AvatarComponentProps {
	photo?: string;
	className?: string;
	key?: string;
	id?: string;
	alt?: string;
	onClick?: (...args: any[]) => void;
	avatarStyle?: React.CSSProperties;
}

export default function AvatarComponent(props: AvatarComponentProps) {
	const classes = useStyles();
	return (
		<>
			{props.photo !== null ? (
				<div
					role="button"
					tabIndex={0}
					onKeyDown={handleKeyActivate(() => props.onClick?.())}
					onClick={props.onClick}
					className={`${props.className}`}
					id={props.id}
					key={props.key}
				>
					<Avatar style={props.avatarStyle ? props.avatarStyle : {}} sizes="44" alt={props.alt} src={props.photo} />
				</div>
			) : (
				<Avatar style={props.avatarStyle ? props.avatarStyle : {}} className={classes.avatarResponsiveCustom} />
			)}
		</>
	);
}
